import PublicationFigurePanels from "./PublicationFigurePanels";
import PublicationFigurePanelsListEditor from "./PublicationFigurePanelsListEditor";
import { useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import useGetter from './useGetter';
import ur from './ur';
import A from './ActionCreators';
import C from './Constants';
import G from './Getters';

function processEvent({dispatch,set,event,state,publicationId}){
    let { type, item, figurePanelId } = event;

    switch(type){
      case "editPanelNumber":{
        set({
          //mode:"editingPublicationList",
          panelIdBeingEdited:figurePanelId,
          panelFieldBeingEdited:"numbering",
        })
        break;
      }
      case "submitPanelNumbering":{

        let { figurePanelId, newNumber } = event;
        let args = {
          publicationId,
          figurePanelId,
          newNumber
        }
        dispatch(A.setPublicationPanelsNumbers({
          _id:publicationId,
          byPanelId:{
            [figurePanelId]:newNumber
          }
        }))

        set({
          panelFieldBeingEdited:undefined,
          panelIdBeingEdited:undefined,
        })

        /*
        return ({
          numberOrderingConflict:G.getPublicationPanelNumberingConflict(state,args)
        })*/


        break;

      }
      case "removeItem":{

        dispatch(A.removePublicationItems({
          _id:publicationId,
          items:[item]
        }))
        break;

      }
      case "addItem":{
        dispatch(A.addPublicationItems({
          _id:publicationId,
          items:[item]
        }))
        break;
      }
      default:{
        throw Error(`Event type not registered... ${JSON.stringify(event)}`);
      }

    }
  /*
    let { item } = event;
    let { _id } = item;
    set({publicationId:_id});
    */
  }




function Div({children},props){
  return (<div {...props}>{children}</div>);
}

export default function PublicationEditor({
  publicationId,
}){

  const dispatch = useDispatch();
  const store = useStore();
  const globalState = store.getState();
  


  const publication = useGetter("getPublication",publicationId);

  const [ state , set ] = ur({
    panelIdBeingEdited:"fp0",
    panelFieldBeingEdited:"numbering",
    mode:"editingPublicationList",

  });

  const onEvent = event => processEvent({dispatch,set,state:globalState,event,publicationId})

  let {
    mode,
  } = state;

  const editingPublicationList = mode === "editingPublicationList";


  let { figurePanels } = publication.items;



  const dir = useGetter("listDirectory",{topLevelDirectory:"publications"});


  

  return (
    <div class="sg-row full-width full-height">

      <div>

        <div class="sg-row">
        <button onClick={() => {

          let newMode = ({
            editingPublicationList:null
          })[mode] || "editingPublicationList";


          set({
            mode:newMode
          });
        }}>{editingPublicationList?"Done":"Edit list"}</button>

          <div class="flex-expand"/>

          <button onClick={() => {
            dispatch(A.publishItem({ itemType:"publication", _id:publicationId}))
          }}>
            Publish
          </button>
        </div>




        {editingPublicationList && <PublicationFigurePanelsListEditor {...{
          onEvent,
          publication,
          editorState:state,
        }}/>}
      </div>


      {(<PublicationFigurePanels {...{
        editorState:state,
        figurePanels, 
        onEvent,
        getNameChangeConflict:({figurePanelId,newNumber}) => {
          return G.getPublicationPanelNumberingConflict(globalState,{figurePanelId,newNumber,publicationId})
        },
        publication,
      }}/>)}
    </div>
  )
}






